import { LocalPersistence } from '@factories/index';

const removeColumnsByTitle = ({
  columns,
  toBeRemoved,
}: {
  columns: { title: string }[];
  toBeRemoved: string[];
}) => {
  // mapping the columns to be removed
  return columns.map(({ title }, index: number) => {
    // mapping the columns name to be removed
    return toBeRemoved.map((name) => {
      // to lower case to cover case sentitive use cases
      if (title.toLowerCase() === name.toLowerCase()) {
        // removing the column from the source
        return delete columns[index];
      }
      return true;
    });
  });
};

const fetcher = async ({ url, options }: any) => {
  const baseURL =
    process.env.REACT_APP_HOST ||
    'https://contentsuite.derbysoft-test.com/content-manager';
  const get_session = new LocalPersistence('session');
  const session = await get_session.getSessionPersistence();
  const token = session.token;

  if (!token) throw new Error('No token found');

  try {
    const resp = await fetch(baseURL + url, {
      ...options,
      headers: {
        'x-access-token': token,
      },
    });
    return resp.json();
  } catch (error: any) {
    throw new Error('Error fetching data');
  }
};

export { removeColumnsByTitle, fetcher };
